import { createAction, props } from '@ngrx/store';
import { LoginFlow, Session, SuccessfulNativeLogin, UpdateLoginFlowBody } from '@ory/client';

const REQUEST_AUTH_LOGIN = '[Auth][Request] Auth Login';
const RESPONSE_SUCCESS_AUTH_LOGIN = '[Auth][Response][Success] Auth Login';
const RESPONSE_FAIL_AUTH_LOGIN = '[Auth][Response][Fail] Auth Login';

export const REQUEST_AUTH_EXTEND = '[Auth][Request] Auth Extend';
export const RESPONSE_SUCCESS_AUTH_EXTEND = '[Auth][Response][Success] Auth Extend';
export const RESPONSE_FAIL_AUTH_EXTEND = '[Auth][Response][Fail] Auth Extend';

export const GetLoginFlow = createAction(
  '[Auth][Request] get login flow',
  props<{ flowId: string }>()
);

export const CreateLoginFlow = createAction(
  '[Auth][Request] create login flow',
  props<{ aal?: string; refresh?: boolean; login_challenge?: string }>()
);

export const SuccessLoginFlow = createAction(
  '[Auth][Success] login flow',
  props<{ flow: LoginFlow }>()
);

export const FailLoginFlow = createAction('[Auth][Fail] login flow', props<{ error: any }>());

export const RequestUpdateLoginFlow = createAction(
  '[Auth][Request] update login flow',
  props<{ data: UpdateLoginFlowBody }>()
);

export const SuccessUpdateLoginFlow = createAction(
  '[Auth][Success] update login flow',
  props<{ result: SuccessfulNativeLogin }>()
);

export const FailUpdateLoginFlow = createAction(
  '[Auth][Fail] update login flow',
  props<{ error?: any; flow?: LoginFlow }>()
);

/**
 * @deprecated
 */
export const RequestLoginAction = createAction(
  REQUEST_AUTH_LOGIN,
  props<{ email?: string; phoneNumber?: string; password: string }>()
);

/**
 * @deprecated
 */
export const ResponseSuccessAuthLoginAction = createAction(
  RESPONSE_SUCCESS_AUTH_LOGIN,
  props<{ session?: Session; userId?: string; payload?: any }>()
);

/**
 * @deprecated
 */
export const ResponseFailAuthLoginAction = createAction(
  RESPONSE_FAIL_AUTH_LOGIN,
  props<{ payload: any }>()
);

export const RequestAuthRefreshAction = createAction(REQUEST_AUTH_EXTEND);

export const ResponseSuccessSessionRefreshAction = createAction(
  RESPONSE_SUCCESS_AUTH_EXTEND,
  props<{ payload?: any }>()
);

export const ResponseFailAuthRefreshAction = createAction(
  RESPONSE_FAIL_AUTH_EXTEND,
  props<{ payload: any }>()
);

export const RequireLogin = createAction(
  '[Auth] Request Login',
  props<{ postLoginRoute?: string; refresh?: boolean; aal?: string }>()
);

export const AtLogin = createAction('[Auth] At Login');
